import { gotToWatchList, fetchSaveAPI , enableVideoSaver } from './utils';
export class WatchListFabButton {
    constructor(applyVideoSaver = ()=>{}) {
        this.savedData = {
            savedVideos : [],
            savedCount: 0
        }
        this.fabButtonEl = null;
        this.lastScrollTop = 0;
        this.mmodule = "fabsavedlp";
        this.mlink = 0;
        this.applyVideoSaver = applyVideoSaver;
    }
  
    init() {
        if(enableVideoSaver()) {
            window.savedData = this.savedData;
            this.fetchSavedVideos();
            this.fabButtonEl = this.fabTemplate;
            this.fabButtonEl.addEventListener('click', this.addButtonTracking.bind(this));
            document.body.appendChild(this.fabButtonEl);
            window.addEventListener("scroll", this.handleScroll.bind(this));
            window.addEventListener("orientationchange", this.handleScroll.bind(this));
        }else {
            if(!window._isODP){
                this.applyVideoSaver();
            }
        }
    }

    handleScroll() {
        const scrollPos = window.scrollY;
        const scrolledDown = this.lastScrollTop > scrollPos;
        const isMobile = window.innerWidth < 768;
        const fabTextElement = this.fabButtonEl.querySelector(".fab-text");
        this.showFabText(fabTextElement,isMobile ? scrolledDown : true);
        this.lastScrollTop = scrollPos;
    }

    showFabText(element,isVisible) {
        element.classList.toggle("show",isVisible);
        this.fabButtonEl.querySelector('.fab-text-wrapper').classList.toggle('hide',this.savedData.savedCount === 0 && !isVisible);
    }

    fetchSavedVideos(){
        fetchSaveAPI()
        .then(response => this.handleFetchResponse(response))
        .catch(error => console.error('Error fetching saved data:', error))
        .finally(()=> {
            this.applyVideoSaver();
        });
    }
    handleFetchResponse(response) {
        try {
        const { count, data } = response;
        this.updateSavedData(count, data);
        this.updateFabButton();
        } catch(err){
            console.log(err);
        }
    }
    updateSavedData(count, data) {
        this.savedData.savedCount = count || 0;
        this.savedData.savedVideos = data.map(d => this.mapSavedVideoData(d));
        window.savedData = this.savedData;
    }
    
    mapSavedVideoData(d) {
        return {
            articleId: d.jsonData.articleId,
            title: d.jsonData.title,
            userTxnId: d.userTxnId,
            link: d.jsonData.url,
            isSaved: true
        };
    }
    
    updateFabButton() {
        const savedCountEl = this.fabButtonEl.querySelector('.saved-count');
        const savedCount = this.savedData.savedCount;
        if (savedCountEl) {
            savedCountEl.textContent = savedCount;
            this.fabButtonEl.classList.toggle('show', savedCount > 0);
        } else {
            console.warn('Saved count element not found.');
        }
    }

    addButtonTracking(el){
        try {
            this.mlink += 1;
            window.wmdPageLink(`${this.mmodule}_${this.mlink}`, el.target);
        } catch (err) {
            console.log(err);d
        }
    }

    get fabTemplate() {
        const template =  `<svg
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                    d="M4.5 0C3.87868 0 3.375 0.503681 3.375 1.125V16.3865C3.375 17.285 4.37641 17.8209 5.12404 17.3225L9 14.7385L12.876 17.3225C13.6236 17.8209 14.625 17.285 14.625 16.3865V1.125C14.625 0.50368 14.1213 0 13.5 0H4.5Z"
                    />
                </svg>
                <span class="fab-text-wrapper">
                    <span class="fab-text show">
                    Watch List
                    </span>
                    <span class="count-wrapper">
                    (<span class="saved-count">
                        0
                    </span>)
                    </span>
                </span>`;
        const fabBtn = document.createElement('a');
        fabBtn.setAttribute('target','_blank')
        fabBtn.setAttribute('id','fab-button-watchlist')
        fabBtn.setAttribute('href',gotToWatchList)
        fabBtn.innerHTML = template;
        
        return fabBtn;
    }
}